import {
  faFacebookF as freeFabFaFacebookF,
  faLinkedinIn as freeFabFaLinkedinIn,
  faYoutube as freeFabFaYoutube
} from '@fortawesome/free-brands-svg-icons'

import {
  faNewspaper as freeFarFaNewspaper,
  faPaperPlane as freeFarFaPaperPlane,
  faTimesCircle as freeFarFaTimesCircle
} from '@fortawesome/free-regular-svg-icons'

import {
  faCheck as freeFasFaCheck,
  faChevronUp as freeFasFaChevronUp,
  faCalendar as freeFasFaCalendar,
  faEye as freeFasFaEye,
  faEyeSlash as freeFasFaEyeSlash,
  faFileAlt as freeFasFaFileAlt,
  faTimes as freeFasFaTimes,
  faPencilAlt as freeFasFaPencilAlt,
  faMinus as freeFasFaMinus,
  faPlus as freeFasFaPlus,
  faSearch as freeFasFaSearch,
  faTrashAlt as freeFasFaTrashAlt,
  faUndoAlt as freeFasFaUndoAlt,
  faXmark as freeFasFaXmark
} from '@fortawesome/free-solid-svg-icons'

export default {freeFabFaFacebookF, freeFabFaLinkedinIn, freeFabFaYoutube, freeFarFaNewspaper, freeFarFaPaperPlane, freeFarFaTimesCircle, freeFasFaCheck, freeFasFaChevronUp, freeFasFaCalendar, freeFasFaEye, freeFasFaEyeSlash, freeFasFaFileAlt, freeFasFaTimes, freeFasFaPencilAlt, freeFasFaMinus, freeFasFaPlus, freeFasFaSearch, freeFasFaTrashAlt, freeFasFaUndoAlt, freeFasFaXmark}